import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeatureSection from './components/FeatureSection';
import RiskWarning from './components/RiskWarning';
import AlternativeSection from './components/AlternativeSection';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '91破解版 - 官方最新版本免费下载 | 安全风险与替代方案指南',
            description:
              '想找91破解版？本页提供91破解版的详细介绍、功能说明、安全风险提示及合法替代方案，帮助用户了解91破解版的真实情况，做出更明智的选择，保护个人设备与数据安全。',
            url: 'https://example.com/',
            inLanguage: 'zh-Hans',
            isPartOf: {
              '@type': 'WebSite',
              name: '应用安全指南',
              url: 'https://example.com/',
            },
          }),
        }}
      />

      <header>
        <Navbar transparent />
        <HeroSection />
      </header>

      <main>
        <FeatureSection />
        <RiskWarning />
        <AlternativeSection />
        <LatestArticles />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}